import { useMissionRedirect } from '@/features/missions/hooks/useMissionRedirect'
import { Spinner } from '@/ui-kit'
import { t } from '@lingui/core/macro'
import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'
import { analytics } from '../analytics/events'
import { formValuesToUserProfile, useProfile, useUpdateProfile, userProfileToFormValues } from './api/profile'
import type { ProfileDetailsFormValues } from './ProfileDetailsForm'
import { ProfileDetailsForm } from './ProfileDetailsForm'

export const ProfileInfo = () => {
  const { data: profile, isLoading } = useProfile()
  const { mutateAsync: updateProfile, isPending: isSubmittingProfile } = useUpdateProfile()
  const { redirect } = useMissionRedirect()
  const navigate = useNavigate()

  const handleSubmit = async (data: ProfileDetailsFormValues) => {
    try {
      await updateProfile(formValuesToUserProfile(data))
      toast.success(t`Profile updated successfully`)
      analytics.profileUpdated()
      if (redirect) navigate(redirect)
    } catch (error) {
      console.error(error)
      toast.error(t`Failed to update profile`)
    }
  }

  return !profile && isLoading ? (
    <div className="flex justify-center py-12">
      <Spinner />
    </div>
  ) : (
    <div className="max-w-[900px]">
      <ProfileDetailsForm
        submitButtonText="Save"
        onSubmit={handleSubmit}
        isSubmittingProfile={isSubmittingProfile}
        defaultValues={profile ? userProfileToFormValues(profile) : undefined}
      />
    </div>
  )
}
